import React, { Component as C } from "react"
import PropTypes from "prop-types"

import Paper from "@cirrus/legacy/app-components/papers/paper/index.jsx"
import PageTitle from "@cirrus/legacy/app-components/titles/pageTitle/index.jsx"
import PaperFooter from "@cirrus/legacy/app-components/footers/paper-footer/index.jsx"
import Button from "@cirrus/legacy/app-components/buttons/button/index.jsx"
import classnames from "classnames"

import styles from "./index.less"

export default class extends C {
  static propTypes = {
    title: PropTypes.string,
    actions: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  }

  static defaultProps = {
    title: null,
    actions: null,
  }

  render() {
    let { children, actions, title } = this.props

    return (
      <div className={classnames(this.props.layoutClassName, styles.layout)}>
        {title ? <PageTitle containerClassName={this.props.titleClassName} title={title} /> : null}

        <Paper className={classnames(this.props.paperClassName, styles.paper)}>{children}</Paper>

        {actions ? (
          <div className={classnames(this.props.footerContainerClassName, styles.footerContainer)}>
            <PaperFooter className={classnames(this.props.footerClassName, styles.footer)}>
              {actions}
            </PaperFooter>
          </div>
        ) : null}
      </div>
    )
  }
}
